import React, { useEffect, useState } from "react";
import useTitle from "../Hooks/useTitle";
import DatagridContext from "../Context/datagridContext";
import ForbiddenPage from "./ForbiddenPage";
import UnauthorizePage from "./UnauthorizePage";
import Datagrid from "../Components/Datagrid";
import toolbar from "../Config/toolbarConfig";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { TooltipComponent } from "@syncfusion/ej2-react-popups";
import { ComboBoxComponent } from "@syncfusion/ej2-react-dropdowns";

const MessageStatusesPage = () => {
  const { t } = useTranslation();
  // const [data, setData] = useState([]);
  const [status, setStatus] = useState(null);
  const [from, setFrom] = useState("");
  const [url, setUrl] = useState("");
  const navigate = useNavigate();

  const baseUrl = process.env.REACT_APP_API_BASE_URL;
  useTitle(`${t("Messages")} | Netileti`);

  const getData = async () => {
    setUrl(`${baseUrl}/webhook/Conversations`);
    setFrom("MessageStatuses");
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const columns = [
    {
      field: "envelopeId",
      headerText: "envelopeId",
      allowEditing: false,
      isPrimaryKey: true,
      visible: false,
    },
    {
      field: "timestamp",
      headerText: t("Time"),
      allowEditing: false,
    },
    {
      field: "messageContent",
      headerText: t("Message Content"),
      allowEditing: false,
      width: "35%",
    },
    {
      field: "receipentPhoneNr",
      headerText: t("Receipent"),
      allowEditing: false,
    },
    {
      field: "senderPhoneNumber",
      headerText: t("Sender"),
      allowEditing: false,
    },
    {
      field: "status",
      headerText: t("Status"),
      textAlign: "Center",
      allowEditing: false,
      template: ({ status }) => (
        <TooltipComponent content={t(`MessageStatuses.${status}.label`)}>
          <span
            className={t(`MessageStatuses.${status}.icon`)}
            style={{ color: t(`MessageStatuses.${status}.color`) }}
          />
        </TooltipComponent>
      ),
      filterTemplate: () => (
        <ComboBoxComponent
          dataSource={[
            { text: t("MessageStatuses.read.label"), value: "read" },
            { text: t("MessageStatuses.delivered.label"), value: "delivered" },
            { text: t("MessageStatuses.sent.label"), value: "sent" },
            { text: t("MessageStatuses.no status.label"), value: "no status" },
            { text: t("MessageStatuses.error.label"), value: "error" },
          ]}
          fields={{ text: "text", value: "value" }}
          change={(e) => {
            const selectedValue = e.value;
            const gridElement = document.getElementById("adaptivebrowser");
            if (gridElement) {
              const grid = gridElement.ej2_instances[0];

              if (grid) {
                if (selectedValue) {
                  // Filtreyi uygula
                  grid.filterByColumn("status", "equal", selectedValue);
                } else {
                  // Filtreyi temizle
                  grid.removeFilteredColsByField("status");
                }
              }
            }
          }}
        />
      ),
    },
    {
      field: "",
      headerText: "",
      allowEditing: false,
      textAlign: "center",
      width: "10%",
      template: ({ envelopeId }) => (
        <button
          onClick={() => navigate(`/messages/${envelopeId}`)}
          className="e-btn e-primary e-outline e-small"
        >
          {t("Details")}
        </button>
      ),
    },
  ];
  
  if (!url) {
    return <div></div>;
  }
  return (
    <div
      className="content e-content-animation"
      style={{ display: "flex", justifyContent: "center", height: "auto" }}
    >
      {status === 401 ? (
        <UnauthorizePage />
      ) : status === 403 ? (
        <ForbiddenPage />
      ) : (
        <DatagridContext.Provider
          value={{
            url,
            toolbar: toolbar("MESSAGE-EXPORT"),
            setStatus,
            from,
          }}
        >
          <Datagrid columns={columns} />
        </DatagridContext.Provider>
      )}
    </div>
  );
};

export default MessageStatusesPage;
